window.slurrpitupPopupRegistration = {};

const siuFormPopup= document.querySelector('slurrpitup-popup-quiz');
const popupOverlay = document.createElement('div');
popupOverlay.classList.add('popup-overlay');
document.body.appendChild(popupOverlay);

const exploreButtons = document.querySelectorAll('.explore-slurrpitup__button');
const closeButton = document.querySelector('.slurrpitup-quiz-close-icon'); 
const templatename = document.body.id;
const isCustomerEnabled = document.body.classList.contains('siu-customer-enabled');

// Variables for the mobile number popup and quiz content
const loginBtnContainer = document.querySelector('.siu-enrolled-container');
const mobileNumberPopup = document.getElementById('mobile-number-popup');
const quizContent = document.querySelector('.quiz-questions__wrapper');
const closeMobilePopupBtn = document.querySelector('.close-btn');
const backBtn = document.getElementById('back-btn');
const otpVerificationConatiner = document.querySelector('.quiz-phone-number-varification');
const mobileNumberVerifyBtn = document.querySelector('.mobile-number-verify-btn');
const newUserSignUp = document.querySelector('.account-signup-container');
const newUserErrorMsg = document.querySelector('.new-siu-registration');
const articleElement = document.querySelector('.article-page__container');

function openQuizPopup() {
  if(!isCustomerEnabled &&  isSiuArticle){
    window.removeEventListener('scroll', handleLogin, { passive: false});
  }
  document.documentElement.classList.add('overflow-hidden');
  document.body.classList.add('overflow-hidden', 'h-100');
  siuFormPopup?.classList.add('visible');   
  popupOverlay.classList.add('visible');
  formViewedEvent();
}

function closePopup() {
  if(!isCustomerEnabled &&  isSiuArticle){
    window.addEventListener('scroll', handleLogin, { passive: false});
  }
  siuFormPopup.classList.remove('visible');
  popupOverlay.classList.remove('visible');
  document.body.classList.remove('overflow-hidden', 'h-100');
  document.documentElement.classList.remove('overflow-hidden');
  newUserErrorMsg.classList.add('hidden');
  document.getElementById('mobile-number').value = '';
  document.querySelector('.quiz-phone-number-otp__input').value = '';
  document.querySelector('.quiz-phone-number__input').value = '';
  document.querySelector('.quiz--input-field').value = '';
  window.slurrpitupPopupRegistration['phone'] = undefined;
  window.slurrpitupPopupRegistration['dob'] = undefined;
  window.slurrpitupPopupRegistration['baby_name'] = undefined;
  document.querySelector('.otp-error_msg').classList.add('hidden');
}

function handleLogin(event) {
  event.preventDefault();
  openQuizPopup();
  quizContent.classList.remove('hidden');
  loginBtnContainer.classList.remove('hidden');
  mobileNumberPopup.classList.add('hidden');
  otpVerificationConatiner.classList.add('hidden');
}

if(!isCustomerEnabled &&  isSiuArticle){
    window.addEventListener('scroll', handleLogin, { passive: false});
}
if (!isCustomerEnabled && isSiuBlog) {
  setupClickInterception();
}

function setupClickInterception() {
  const articleList = document.querySelector('.blog-articles__list');
  const subCategoryContainer = document.querySelector('.sub-category-main-container');

  // Attach event listener only if either container exists
  if (!articleList && !subCategoryContainer) return;

  document.addEventListener('click', handleProtectedClick, true); // use capture phase
}
/*
  This function intercepts clicks on blog article links and sub-category items
  when the customer is not enabled. It prevents redirection and instead
  displays the Slurrp It Up quiz form.
 */
function handleProtectedClick(event) {
  const articleList = document.querySelector('.blog-articles__list');
  const subCategoryContainer = document.querySelector('.sub-category-main-container');
  const clickedLink = event.target.closest('a');
  const clickedSubCategoryItem = event.target.closest('.sub-category-item');
  const isArticleLink = clickedLink && articleList && articleList.contains(clickedLink);
  const isSubCategoryClick = clickedSubCategoryItem && subCategoryContainer && subCategoryContainer.contains(clickedSubCategoryItem);
  const isCustomerEnabled = document.body.classList.contains('siu-customer-enabled');
  if ((isArticleLink || isSubCategoryClick) && !isCustomerEnabled) {
    event.preventDefault();
    event.stopImmediatePropagation();
    openQuizPopup();
    quizContent.classList.remove('hidden');
    loginBtnContainer.classList.remove('hidden');
    mobileNumberPopup.classList.add('hidden');
    otpVerificationConatiner.classList.add('hidden');
    return false;
  }
}

// Close the main popup on overlay click
popupOverlay?.addEventListener('click', function() {
  closePopup()
});

// Close the main popup on close icon click
closeButton?.addEventListener('click', function() {
  closePopup()
});

// Show the mobile number popup on login button click and hide quiz content
loginBtnContainer?.addEventListener('click', function() {
  mobileNumberPopup.classList.remove('hidden');
  loginBtnContainer.classList.add('hidden');
  otpVerificationConatiner.classList.add('hidden');
  quizContent.classList.add('hidden');
});


backBtn?.addEventListener('click', function() {
  mobileNumberPopup.classList.add('hidden');
  loginBtnContainer.classList.remove('hidden');    
  quizContent.classList.remove('hidden');
});

  //--------------------------------------------------------
  // EVENT:: SIU Form Viewed 
  //--------------------------------------------------------
  function formViewedEvent() {  
    clevertap.event.push('SIU_Form_viewed', {
      'Name': window.customerFullName,
      'Identity': window.customerID,
      'Email': window.customerEmail,
      'Phone': window.customerPhone,
      'Login_status': window.loginStatus,
      'SIU_status': window.siuStatus
    });

    window.dataLayer.push({
      'event': 'SIU_Form_viewed',
      'Name': window.customerFullName,
      'Identity': window.customerID,
      'Email': window.customerEmail,
      'Phone': window.customerPhone,
      'Login_status': window.loginStatus
    });
  }

class SlurrpItUpQuizPopup extends HTMLElement {
  constructor() {
    super();
    
    this.quizMainContainer = this.querySelector('.quiz-questions__wrapper');
    this.mobileNumberPopup = this.querySelector('#mobile-number-popup');
    this.otpVerificationConatiner = this.querySelector('.quiz-phone-number-varification');
    this.loginBtnContainer = this.querySelector('.siu-enrolled-container');
    this.loader = this.querySelector('.form-submit-loader__container');
    this.inputField = this.querySelector('.slurrpitup-text-field-container .quiz--input-field');
    this.buttonClicked = '';
    
    this.initQuiz();
  }

  connectedCallback() {
    if (this._sliderInitialized) return;
    this.initQuizSlider();
    this._sliderInitialized = true;
  }
  
  initQuizSlider() {
    if (typeof Splide === 'undefined') return;
    this.sliderElement = this.querySelector('.quiz-slider__container')
    this.slider = new Splide( this.sliderElement, {
      type: 'fade',
      perPage: 1,
      pagination: false,
      arrows: false,
      drag : false,
    });

    const carousel = this.slider
    const bar = this.querySelectorAll('.progress-bar__inner').forEach((eachBar) => {
      carousel.on('mounted move', function () {
        var end = carousel.Components.Controller.getEnd() - 1 ;
        var rate = Math.min((carousel.index) / end, 1);
        eachBar.style.width = String(100 * rate) + '%';
      });
    })

    this.slider.mount();

    this.slurrpitupCustomer = this.getAttribute('data-slurrpitup-customer');
    this.firstPage = this.getAttribute('data-first-page');

    if (this.slurrpitupCustomer == 'true') {
      const totalSlides = this.slider.length;
      this.slider.go(totalSlides - 1);
    }
  }

  initQuiz() {
    const otpSendBtn = this.querySelector('.mobile-number-varify-container .mobile-number-verify-btn');
    
    otpSendBtn.addEventListener('click', (e) => { 
      this.handleAllQuestionsSubmit();   
      const name = window.slurrpitupPopupRegistration.baby_name
      const dob = window.slurrpitupPopupRegistration.dob
      const phone = `+91${window.slurrpitupPopupRegistration.phone}`
      const whatsappChecked = this.querySelector('input[name="whatsapp-message"]').checked

      if (whatsappChecked && name !== undefined && dob !== undefined && phone !== undefined) {
        this.sendRegisterOTP();
        // ------------------------------------------
        // SIU Form Entered
        // ------------------------------------------
        clevertap.event.push('SIU_form_entered', {
          'Name':  window.slurrpitupPopupRegistration.baby_name,
          'Identity': window.customerID,
          'Email': window.customerEmail,
          'dob': window.slurrpitupPopupRegistration.dob,
          'Phone': window.slurrpitupPopupRegistration.phone,
          'Login_status': window.loginStatus,
          'SIU_status': window.siuStatus
        })

        window.dataLayer.push({
          'event': 'SIU_form_entered',
          'Name':  window.slurrpitupPopupRegistration.baby_name,
          'Identity': window.customerID,
          'Email': window.customerEmail,
          'dob': window.slurrpitupPopupRegistration.dob,
          'Phone': window.slurrpitupPopupRegistration.phone,
          'Login_status': window.loginStatus
        })
      } else {
        console.log("validation Failed");
      }
    });

    const textField = this.querySelector('input.quiz--input-field')
    textField.addEventListener('input', function() {
      const lettersOnly = /^[A-Za-z\s]*$/; // Allows letters and spaces
      if (!lettersOnly.test(textField.value)) {
        textField.value = textField.value.replace(/[^A-Za-z\s]/g, ''); // Remove invalid characters
      }
    })

    this.loginBtnContainer.addEventListener('click', () => {
      // ------------------------------------------
      // SIU Form Login Clicked
      // ------------------------------------------
        clevertap.event.push('SIU_Form_login_clicked', {
          'Name':  'NA',
          'Identity': 'NA',
          'Email': 'NA',
          'dob': 'NA',
          'Phone': 'NA',
          'SIU_status': window.siuStatus
        })

        window.dataLayer.push({
          'event': 'SIU_Form_login_clicked',
          'Name':  'NA',
          'Identity': 'NA',
          'Email': 'NA',
          'dob': 'NA',
          'Phone': 'NA'
        })
    })


    // Add event listener to the input field
    this.inputField?.addEventListener('blur', () => {
      clevertap.event.push('SIU_form_started', {
        'Name': this.inputField.value,
        'Identity': window.customerID,
        'Email': window.customerEmail,
        'Phone': window.customerPhone,
        'Login_status': window.loginStatus,
        'SIU_status': window.siuStatus
      });

      window.dataLayer.push({
        'event': 'SIU_form_started',
        'Name': this.inputField.value,
        'Identity': window.customerID,
        'Email': window.customerEmail,
        'Phone': window.customerPhone,
        'Login_status': window.loginStatus
      });
    });
    


    this.verifyBtn = this.querySelector('.quiz_arrow--next-btn.quiz-custom-next-arrow');
    this.verifyBtn?.addEventListener('click', (e) => {
      if (e.target.classList.contains('login-otp')) {
        this.verifyLoginOTP(e);
      } else {
        this.verifyRegisterOTP();
        this.loader.classList.remove('hidden');
      }
    })

    this.loginFormOtp = this.querySelector('#submit-number');
    this.loginFormOtp.addEventListener('click', (e) => {
      this.number = this.querySelector('#mobile-number').value;
      
      if (isValidPhoneNumber(this.number)) {
        this.loginSendOtp(this.number);
      } else {
        this.numberErrorMessage = this.querySelector('.mobile_number-error');
        this.numberErrorMessage.classList.remove('hidden');
        this.numberErrorMessage.textContent = '*Please enter a valid phone number';
      }
    })


    this.addEventListener('click', function(event) {
      // Track clicks on #submit-number or .mobile-number-verify-btn buttons
      if (event.target && (event.target.id === 'submit-number' || event.target.classList.contains('mobile-number-verify-btn'))) {
          this.trackButtonClick(event); // No need for this.trackButtonClick, just call the function directly
          this.startResendTimer(); //start the otp timer from the start
      }

      // Trigger OTP resend when .resend-otp-btn is clicked
      if (event.target && event.target.classList.contains('resend-otp-btn')) {
        if (event.target.getAttribute('disabled') !== 'true') {
          this.resendOTP();
          this.startResendTimer();
        }
      }
    });
  }

  hideQuizFormAndShowOtpVarification() {
    this.quizMainContainer.classList.add('hidden');
    this.mobileNumberPopup.classList.add('hidden');
    this.otpVerificationConatiner.classList.remove('hidden');
    this.loginBtnContainer.classList.add('hidden');
  }

  handleSlideSubmit() {
    const currentSlide = this.querySelector('.splide__slide.is-active')
    const blockType = currentSlide.dataset.blockType?.toLowerCase()
    switch (blockType) {
    case 'dob':
      this.handleDOBSubmit(currentSlide)
      break;
    case 'questions' || 'question':
      this.handleQuestionSubmit(currentSlide)
      break;
    case 'phone_number':
      this.handlePhoneSubmit(currentSlide)
      break;
    case 'all_questions':
      this.handleAllQuestionsSubmit(currentSlide)

    }
  }

  handleDOBSubmit(currentSlide, dobQuestionId) {
    const questionId = dobQuestionId || currentSlide.dataset.questionId 
    const customerId = currentSlide.dataset.customerId
    const dobType = this.querySelector('.quiz-date-of-birth__container').dataset.dobType;
    const dobErrorMsg = currentSlide.querySelector('.quiz-date-of-birth__container .quiz_input--error');
    const currentDate = new Date();
    let date = null;
    let month = null;
    let year = null;
    if(dobType === 'dropdown'){
      date = parseInt(this.querySelector('.quiz-date--input:checked')?.value);
      month = this.querySelector('input[name="month"]:checked')?.value;
      year = parseInt(this.querySelector('input[name="year"]:checked')?.value);
      
      if (date != undefined && month != undefined && year != undefined && questionId.length > 0) {
        dobErrorMsg.innerHTML = ''
        date = String(date).padStart(2, '0');
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const monthNumber = monthNames.indexOf(month) + 1;
        const formattedMonthNumber = String(monthNumber).padStart(2, '0');
        month = formattedMonthNumber;
        let dob = `${date}-${month}-${year}`;
        // Convert dobString to a Date object
        dob = new Date(year, monthNumber - 1, date); // monthNumber - 1 because JS months are 0-based
        
        // Normalize times to midnight for accurate date-only comparison
        dob.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);

        if (dob > currentDate) {
          dobErrorMsg.innerHTML = "The selected date of birth cannot be in the future.";
          return; // Stop execution if DOB is invalid
        }
        dob = `${date}-${month}-${year}`;
        window.slurrpitupPopupRegistration['id'] = parseInt(customerId);
        window.slurrpitupPopupRegistration[`${questionId}`] = dob;

        //======================================== 
        // cleverTap event for Baby's Date Of Birth event
        // ========================================
        clevertap.event.push('Baby DOB', {
          'Name':  window.customerFullName,
          'Identity': window.customerID,
          'Email': window.customerEmail,
          'Phone': window.customerPhone,
          'DOB': new Date(dob)
        });
      } else {
        // TODO
        dobErrorMsg.innerHTML = '*Please fill the details above and proceed to next step';
      }
    } else if(dobType === 'calendar'){
      const selectedDob = currentSlide.querySelector('.quiz-date-of-birth__container input[type="date"]')?.value;
      if(selectedDob !== "") {
        const dob = new Date(selectedDob);
        // Normalize times to midnight for accurate date-only comparison
        dob.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);
        if (dob > currentDate) {
          dobErrorMsg.innerHTML = "The selected date of birth cannot be in the future.";
          return; // Stop execution if DOB is invalid
        }
        dobErrorMsg.innerHTML = ''
        const dateArray = selectedDob.split('-');
        date = dateArray[2];
        month = dateArray[1];
        year = dateArray[0];
        const childDob = `${date}-${month}-${year}`
        window.slurrpitupPopupRegistration['id'] = parseInt(customerId)
        window.slurrpitupPopupRegistration[`${questionId}`] = childDob

        //======================================== 
        // cleverTap event for Baby's Date Of Birth event
        // ========================================
        clevertap.event.push('Baby DOB', {
          'Name':  window.customerFullName,
          'Identity': window.customerID,
          'Email': window.customerEmail,
          'Phone': window.customerPhone,
          'DOB': new Date(childDob)
        });
      } else {
        dobErrorMsg.innerHTML = '*Please fill the details above and proceed to next step';
      }
    }
  }

  handleQuestionSubmit(currentSlide) {
    const questionType = currentSlide.dataset.questionType?.toLowerCase()
    switch (questionType) {
    case 'input':
      this.handleTextSubmit(currentSlide)
      break;
    case 'dropdown':
      this.handleDropdownSubmit(currentSlide);
      break;
    }
  }

  handleTextSubmit(currentSlide, babyNameQuestionId) {
    const value = currentSlide.querySelector('input.quiz--input-field').value
    const questionId = babyNameQuestionId || currentSlide.dataset.questionId
    if (value.length > 0 && questionId?.length > 0 ) {
      currentSlide.querySelector('.slurrpitup-quiz__questions .quiz_input--error').innerHTML = ''
      slurrpitupPopupRegistration[questionId] = value
    } else {
      // TODO
      currentSlide.querySelector('.slurrpitup-quiz__questions .quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step';
    }    
  }
  
  
  stripNonNumeric(inputString) {
    return inputString.replace(/\D/g, '');
  }

  handleDropdownSubmit(currentSlide) {
    const value = currentSlide.querySelector('input:checked')?.value
    if (value != undefined && currentSlide.dataset.questionId?.length > 0) {
      currentSlide.querySelector('.quiz_input--error').innerHTML = ''
      const parsedValue = parseInt(value)
      slurrpitupPopupRegistration[currentSlide.dataset.questionId] = parsedValue
    } else {
      // TODO
      currentSlide.querySelector('.quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step'
    }
  }

  handlePhoneSubmit(currentSlide) {
    const value = this.querySelector('input[type="number"]')?.value
    const whatsappChecked = this.querySelector('input[name="whatsapp-message"]').checked
    const termsandConditons = this.querySelector('input[name="t_c_description"]')
    const guidelines = this.querySelector('input[name="guidelines-description"]')
    const mobileNoStartDigits = /^[6789]/.test(value)

    if (isValidPhoneNumber(value) && mobileNoStartDigits) {
      currentSlide.querySelector('.quiz-phone-number__container .quiz_input--error').innerHTML = '';
      const parsedValue = parseInt(value)
      slurrpitupPopupRegistration['phone'] = parsedValue
    } else {
      // TODO
      currentSlide.querySelector('.quiz-phone-number__container .quiz_input--error').innerHTML = '*Invalid phone number';
      return
    }

    if (whatsappChecked) {
      currentSlide.querySelector('.quiz-phone-number__container .quiz_input--error').innerHTML = '';

      //=================================
      // cleverTap event for Quiz completed
      //================================= 
      clevertap.event.push('Quiz Completed', {
        'Name':  window.customerFullName,
        'Identity': window.customerID,
        'Email': window.customerEmail,
        'Phone': window.customerPhone,
        'DOB': new Date(window.slurrpitupPopupRegistration.dob)
      })
    }else{
      currentSlide.querySelector('.quiz-phone-number__container .quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step';
      return
    }

    if (termsandConditons && guidelines) {
      if (termsandConditons.checked && guidelines.checked) {
        // Execute your code here that depends on both being checked

        //=================================
        // cleverTap event for Quiz completed
        //================================= 
        clevertap.event.push('Quiz Completed', {
          'Name':  window.customerFullName,
          'Identity': window.customerID,
          'Email': window.customerEmail,
          'Phone': window.customerPhone,
          'DOB': new Date(window.slurrpitupPopupRegistration.dob)
        })
      } else {
        currentSlide.querySelector('.quiz-phone-number__container .quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step';
        return
      }
    }
  }

  handleAllQuestionsSubmit() {
    const currentSlide = this.querySelector('.quiz--content__wrapper.splide__slide');
    const questionId_1 = currentSlide.getAttribute('data-question-id-1');
    const questionId_2 = currentSlide.getAttribute('data-question-id-2');
    const questionId_3 = currentSlide.getAttribute('data-question-id-3');

    this.handleTextSubmit(currentSlide, questionId_2)
    this.handleDOBSubmit(currentSlide, questionId_1)
    this.handlePhoneSubmit(currentSlide, questionId_3)
  }

  startResendTimer() {
    let countdown = 300;
    const resendButton = document.querySelector('.resend-otp-btn');
    const timerElement = document.getElementById('timer');
    if(window.sitOtpTimer) {
      clearInterval(window.sitOtpTimer);
    }
    if (resendButton && timerElement) {
      resendButton.setAttribute('disabled', 'true');
      window.sitOtpTimer = setInterval(function() {
        if (countdown > 0) {
          const minutes = Math.floor(countdown / 60);
          const seconds = countdown % 60;

          timerElement.textContent = `${minutes}:${seconds.toString().padStart(2, '0')} secs`;

          if (countdown <= 10) {
            timerElement.style.color = "red";
          } else {
            timerElement.style.color = "green";
          }
          countdown--;
        } else {
          resendButton.removeAttribute('disabled');
          timerElement.textContent = '';
          clearInterval(window.sitOtpTimer);
        }
      }, 1000);
    }
  }

  sendRegisterOTP() {
    const postOTP = window.slurrpitupPopupRegistration
    const url = 'https://marmeto.wholsumfoods.com/api/register';

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        dob: window.slurrpitupPopupRegistration.dob,
        phone: window.slurrpitupPopupRegistration.phone,
        baby_name: window.slurrpitupPopupRegistration.baby_name
      })
    })
    .then(response => response.json())
    .then(data => {
      if(data.message == "customer already registered") {
        this.querySelector('.register-error-message').innerHTML = "Already registered with this number. Please login";
        this.querySelector('.register-error-message').classList.remove('hidden');

        //to show the login flow
        let phoneNumber = document.querySelector(".quiz-phone-number__input").value;
        document.querySelector("#mobile-number").value = phoneNumber;
        document.querySelector('#mobile-number-popup')?.classList.remove('hidden');
        document.querySelector('.siu-enrolled-container')?.classList.add('hidden');
        document.querySelector('.quiz-phone-number-varification')?.classList.add('hidden');
        document.querySelector('.quiz-questions__wrapper')?.classList.add('hidden');
        document.querySelector("#submit-number").click();
        // ------------------------------------------
        // SIU Login Initiated
        // ------------------------------------------
        clevertap.event.push('SIU_login_initiated', {
          'Name':  window.slurrpitupPopupRegistration.baby_name,
          'Identity': window.customerID,
          'Email': window.customerEmail,
          'dob': window.slurrpitupPopupRegistration.dob,
          'Phone': window.slurrpitupPopupRegistration.phone,
          'SIU_status': window.siuStatus
        })

        window.dataLayer.push({
          'event': 'SIU_login_initiated',
          'Name':  window.slurrpitupPopupRegistration.baby_name,
          'Identity': window.customerID,
          'Email': window.customerEmail,
          'dob': window.slurrpitupPopupRegistration.dob,
          'Phone': window.slurrpitupPopupRegistration.phone
        })
      } else {
        localStorage.setItem('key', data.session_id);
        this.hideQuizFormAndShowOtpVarification();
        this.querySelector('.otp-success_msg').classList.remove('hidden');
      }
    })
    .catch(error => console.error('Error:', error));
    
  }

  verifyRegisterOTP() {
    const url = 'https://marmeto.wholsumfoods.com/api/register/verify';
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        otp: parseInt(this.querySelector('.quiz-phone-number-otp__input').value),
        session_id: localStorage.getItem('key'),
        return_to: window.location.href
      })
    })
    .then(response => {
      this.loader.classList.add('hidden');
      
      // Return the response JSON, regardless of status
      return response.json().then(data => ({
        status: response.status,
        data
      }));
    })
    .then(result => {
      const { status, data } = result;
      const customerEmail = data.email;
      const customerTags = data.tags;
      const auth_token = data.token;
      if (status === 200) {
        window.removeEventListener('scroll', handleLogin);
        // ------------------------------------------
        // SIU Form Submitted
        // ------------------------------------------
        clevertap.event.push('SIU_form_submitted', {
          'Name':  window.slurrpitupPopupRegistration.baby_name,
          'Identity': window.customerID,
          'Email': window.customerEmail,
          'dob': window.slurrpitupPopupRegistration.dob,
          'Phone': window.slurrpitupPopupRegistration.phone,
          'Login_status': window.loginStatus,
          'SIU_status': window.siuStatus
        });

        clevertap.onUserLogin.push({
          "Site": {
            "Name": window.slurrpitupPopupRegistration.baby_name,      // String
            "Identity": `+91${window.slurrpitupPopupRegistration.phone}`,      // String or number
            "Email": customerEmail,         // Email address of the user
            "Phone": `+91${window.slurrpitupPopupRegistration.phone}`,
          // optional fields. controls whether the user will be sent email, push etc.
            // "MSG-email": checkboxInput.checked, // Disable email notifications
            "MSG-sms": true,                    // Enable sms notifications
            "MSG-whatsapp": true,               // Enable WhatsApp notifications
            "Tags": customerTags
          }
        });

        window.dataLayer.push({
          'event': 'SIU_form_submitted',
          'Name':  window.slurrpitupPopupRegistration.baby_name,
          'Identity': window.customerID,
          'Email': window.customerEmail,
          'dob': window.slurrpitupPopupRegistration.dob,
          'Phone': window.slurrpitupPopupRegistration.phone,
          'Login_status': window.loginStatus
        });

        // Added to check the signups from meta campaign
        window.dataLayer.push({
          'event': 'SIU_form_submit', 
          'Name':  window.slurrpitupPopupRegistration.baby_name,
          'Identity': window.customerID,
          'Email': window.customerEmail,
          'dob': window.slurrpitupPopupRegistration.dob,
          'Phone': window.slurrpitupPopupRegistration.phone,
          'Login_status': window.loginStatus
        });
        fbq('trackCustom', 'siu_form_submit', {
          'Identity': window.customerID,
          'Login_status': window.loginStatus
        });
        if(customerEmail){
          sfSetCookie('sf_email', customerEmail, { days: 30, sameSite: 'Lax', secure: location.protocol === 'https:' });
        }
        if(auth_token){
          sfSetCookie('sf_auth_token', auth_token, { days: 30, sameSite: 'Lax', secure: location.protocol === 'https:' });
        }
        closePopup();
        window.location.replace(data.url);
      } else {
        // Handle the error message from the data
        console.error('Error:', data.message);
        this.errorMessage = this.querySelector('.otp-error_msg')
        this.errorMessage.textContent = data.message;
        this.errorMessage.classList.remove('hidden');
        this.querySelector('.otp-success_msg').classList.add('hidden');
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

  loginSendOtp(number) {
    const url = 'https://marmeto.wholsumfoods.com/api/login';
    
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        phone: number
      })
    })
    .then(response => response.json())
    .then(result => {
      if(result.message === 'consider registartion') {
        //TODO: Close OTP Popup
        document.querySelector('.quiz-phone-number-varification')?.classList.add('hidden');
        document.querySelector('#mobile-number-popup')?.classList.add('hidden');
        //TODO: Open slurrpitup-quiz popup
        document.querySelector('.quiz-questions__wrapper')?.classList.remove('hidden');
        document.querySelector('.siu-enrolled-container')?.classList.remove('hidden');  
        document.querySelector('.new-siu-registration').classList.remove('hidden');        
      }
      if (result.message != "otp sent and valid for 5 mins") {
        const errorMSg = this.querySelector('.otp-error_msg')
        errorMSg.innerHTML = 'OTP is Failed'
        this.querySelector('.otp-success_msg').classList.add('hidden');
        console.error('Error:', result.message);
      } else {
        localStorage.setItem('session', result.session_id);
        this.loginOTPBtn = this.querySelector('.quiz_arrow--next-btn.quiz-custom-next-arrow')
        if (this.loginOTPBtn) {
          this.querySelector('.quiz_arrow--next-btn.quiz-custom-next-arrow').classList.add('login-otp');
        }
        this.hideQuizFormAndShowOtpVarification();
        this.querySelector('.otp-success_msg').classList.remove('hidden');
         // ------------------------------------------
        // SIU Login Initiated
        // ------------------------------------------
        clevertap.event.push('SIU_login_initiated', {
          'Name':  'NA',
          'Identity': window.customerID,
          'Email': window.customerEmail,
          'dob': "NA",
          'Phone': this.number
        })

        window.dataLayer.push({
          'event': 'SIU_login_initiated',
          'Name':  'NA',
          'Identity': window.customerID,
          'Email': window.customerEmail,
          'dob': "NA",
          'Phone': this.number
        })
      }
    })
    .catch(error => console.error('Error:', error));
  }

  verifyLoginOTP() {
    const url = 'https://marmeto.wholsumfoods.com/api/login/verify';
    const otpValue = this.querySelector('.quiz-phone-number-otp__input').value
    if (otpValue != '') {
      this.querySelector('.otp-error_msg').innerHTML = "";
      this.querySelector('.otp-error_msg').classList.add('hidden');
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          otp: parseInt(this.querySelector('.quiz-phone-number-otp__input').value),
          session_id:localStorage.getItem('session'),
          return_to: window.location.href
        })
      })
      .then(response => response.json())
      .then(result => {
        const { message, url, token, email } = result;
        if (message === 'customer logged in') {
          this.loader.classList.add('hidden');
          this.querySelector('.otp-error_msg').classList.add('hidden');
          // ------------------------------------------
          // SIU Login Success
          // ------------------------------------------
          clevertap.event.push('SIU_Log_in_success', {
            'Name':  "NA",
            'Identity': window.customerID,
            'Email': window.customerEmail,
            'dob': "NA",
            'Phone': this.number,
            'SIU_status': window.siuStatus
          })
          
          window.dataLayer.push({
            'event': 'SIU_Log_in_success',
            'Name':  "NA",
            'Identity': window.customerID,
            'Email': window.customerEmail,
            'dob': "NA",
            'Phone': this.number
          })
          sessionStorage.setItem('customer-accessed', true)
          closePopup();
          if(email){
            sfSetCookie('sf_email', email, { days: 30, sameSite: 'Lax', secure: location.protocol === 'https:' });
          }
          if(token){
            sfSetCookie('sf_auth_token', token, { days: 30, sameSite: 'Lax', secure: location.protocol === 'https:' });
          }
          window.removeEventListener('scroll', handleLogin);
          window.location.replace(url);
        } else {
          this.querySelector('.otp-error_msg').innerHTML = "Please enter the valid OTP"
          this.querySelector('.otp-error_msg').classList.remove('hidden');
          this.querySelector('.otp-success_msg').classList.add('hidden')
        }
      })
      .catch(error => console.error('Error:', error));
      
    } else {
      this.querySelector('.otp-error_msg').innerHTML = "Please enter the valid OTP";
      this.querySelector('.otp-error_msg').classList.remove('hidden');
      this.querySelector('.otp-success_msg').classList.add('hidden')
    }
  }

  trackButtonClick(event) {
    if (event.target.id === 'submit-number') {
        this.buttonClicked = 'session'; // Set flag to 'session'
    } else if (event.target.classList.contains('mobile-number-verify-btn')) {
        this.buttonClicked = 'key'; // Set flag to 'key'
    }
  }

  resendOTP() {
    const url = 'https://marmeto.wholsumfoods.com/api/resend';
    const otpValue = this.querySelector('.quiz-phone-number-otp__input').value;

    // Clear any existing error messages
    this.querySelector('.otp-error_msg').innerHTML = "";
    this.querySelector('.otp-error_msg').classList.add('hidden');

      // Determine which localStorage key to use based on the button clicked
      let storedSessionId;

      if (this.buttonClicked === 'session') {
          storedSessionId = localStorage.getItem('session');
      } else if (this.buttonClicked === 'key') {
          storedSessionId = localStorage.getItem('key');
      } else {
          console.error('No valid button click recorded.');
          this.querySelector('.otp-error_msg').textContent = 'Please try again.';
          this.querySelector('.otp-error_msg').classList.remove('hidden');
          return;
      }
  
      // If no session ID found, return early
      if (!storedSessionId) {
          console.error('No session or key found in localStorage.');
          this.querySelector('.otp-error_msg').textContent = 'Session or key missing. Please try again.';
          this.querySelector('.otp-error_msg').classList.remove('hidden');
          return;
      }

    // Send the request to resend OTP
    fetch(url, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          session_id: storedSessionId // Send session_id from local storage
      })
    })
    .then(response => response.json())
    .then(result => {
        const { message, session_id } = result;

        const errorMsg = this.querySelector('.otp-error_msg');
        const successMsg = this.querySelector('.otp-success_msg');

        if (message === 'Multiple attempts , Try after one hour') {
          errorMsg.textContent = result.message;
          errorMsg.classList.remove('hidden');
          successMsg.classList.add('hidden');
        } else if (message === 'otp sent and valid for 5 mins') {
          // OTP sent successfully
          successMsg.classList.remove('hidden');
          errorMsg.classList.add('hidden');
        } else {
          // Invalid OTP or other errors
          errorMsg.textContent = 'Invalid OTP';
          errorMsg.classList.remove('hidden');
          successMsg.classList.add('hidden');
          console.error('Error:', result.message);
        }
    })
    .catch(error => {
        console.error('Error:', error);
        this.querySelector('.otp-error_msg').textContent = 'An error occurred, please try again.';
        this.querySelector('.otp-error_msg').classList.remove('hidden');
    });
  }


}
customElements.define('slurrpitup-popup-quiz', SlurrpItUpQuizPopup)

class CustomDropDown extends HTMLElement {
  constructor() {
    super();
    this.init()
  }

  init() {
    this.querySelector('.show-dropdown__button')?.addEventListener('click', (event)=>{
      this.showDropdownOptions(event)
    })

    this.querySelector('.close-dropdown-options')?.addEventListener('click', ()=>{
      this.hideDropdownOptions()
    })

    this.addEventListener('change', (event)=>{
      this.handleOnValueChange(event)
    })
    this.bodyClickClose();
  }

  showDropdownOptions(event) {
    document.querySelectorAll('.quiz__drop-down').forEach((each)=> each.classList.remove('active'));
    this.querySelector('.quiz__drop-down').classList.add('active');
    document.querySelector('.splide__track').classList.add('show-overlay') 
  }

  hideDropdownOptions() {
    this.querySelector('.quiz__drop-down').classList.remove('active');
    document.querySelector('.splide__track').classList.remove('show-overlay') 
    
  }

  handleOnValueChange(event) {
    this.querySelector('.selected--value').innerHTML = event.target.value;
    this.suffix = this.querySelector('.selected-value-suffix')
    if (this.suffix) {
      const suffixValue = event.target.dataset.suffix
      this.suffix.innerHTML = suffixValue
    }
    this.hideDropdownOptions()
    this.querySelector('.select-date').classList.add('hide-element');
  }

  bodyClickClose() {
    window.onclick = function (event) {
      if (!event.target.closest('.quiz__drop-down') && !event.target.closest('.show-dropdown__button') && !event.target.closest('.mm-ajaxcart-open') && !event.target.closest('.mm-ajaxcart') && !event.target.closest('.slide-container')) {
        document.querySelectorAll('.quiz__drop-down').forEach(function (e) {
          e.classList.remove('active');
          document.querySelector('.splide__track').classList.remove('show-overlay') 
        })
      }
    }
  }
}

customElements.define('custom-dropdown', CustomDropDown)

function isValidPhoneNumber(phoneNumber) {
 // Define a regular expression for a phone number with a maximum length of 10 digits
 const phoneRegex = /^\d{10}$/;

 // Test if the provided phone number matches the regex
 return phoneRegex.test(phoneNumber);
}
